export const simpleDateToIsoString = (date: string): string => {
  const split = date.indexOf(' ');
  return `${date.substring(0, split)}T${date.substring(split + 1)}:00.000`;
};
